import { FunctionComponent, useEffect } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import languages from '../../Data/languages';
import type { Template } from '../../types';

interface CampaignClosedPageProps {
  template: Template;
}

export const CampaignClosedPage: FunctionComponent<CampaignClosedPageProps> = ({ template }) => {
  const appInsights = useAppInsightsContext();
  useEffect(() => {
    appInsights.trackPageView({ name: 'CampaignClosedPage.tsx' });
  }, [appInsights]);
  const language = template.language.name;
  return (
    <div className="body">
      <h2>{languages.ACCEPTING_RESPONSES[language]}</h2>
    </div>
  );
};
